import { render, staticRenderFns } from "./TableCampaigns.vue?vue&type=template&id=04f588fc&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "@/scss/general.scss?vue&type=style&index=0&id=04f588fc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f588fc",
  null
  
)

export default component.exports